import React from "react";
import { LayoutDashboard, Users, CalendarCheck, Receipt, Workflow, Smartphone, CheckCircle2, MessageCircle } from "lucide-react";
import { LinkShell, waLink, fadeUp } from "./LinkShell";

const SOLUTIONS = [
  { id: "dashboard", icon: LayoutDashboard, name: "Dashboard Operasional", desc: "Pantau penjualan, stok, dan performa tim secara real-time dalam satu layar." },
  { id: "crm", icon: Users, name: "CRM & Manajemen Leads", desc: "Kelola leads, follow-up pelanggan, dan ukur konversi tim sales dengan rapi." },
  { id: "booking", icon: CalendarCheck, name: "Sistem Booking & Klinik", desc: "Jadwal booking, rekam medis, dan antrean pasien yang terintegrasi." },
  { id: "pos", icon: Receipt, name: "Aplikasi POS & Kasir", desc: "Transaksi cepat, multi-metode pembayaran, dan laporan kasir otomatis." },
  { id: "automasi", icon: Workflow, name: "Automasi Bisnis", desc: "Otomatiskan reminder, laporan, dan alur kerja berulang agar tim fokus ke hal penting." },
  { id: "mobile", icon: Smartphone, name: "Aplikasi Mobile Custom", desc: "Aplikasi mobile sesuai kebutuhan bisnis untuk tim maupun pelanggan Anda." },
];

const FEATURES = ["Sistem booking", "Rekam medis", "POS & kasir", "Multi-cabang", "Laporan CS/CRM"];

function SolutionCard({ s }) {
  const Icon = s.icon;
  return (
    <div data-testid={`solusi-card-${s.id}`} className="rounded-2xl border border-zinc-200 bg-white p-5 transition-[transform,border-color] duration-200 hover:-translate-y-0.5 hover:border-lime-400">
      <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-lime-100 text-lime-700"><Icon className="h-5 w-5" /></span>
      <h3 className="mt-3 font-bold">{s.name}</h3>
      <p className="mt-1 text-sm leading-relaxed text-zinc-500">{s.desc}</p>
    </div>
  );
}

function PortfolioCard() {
  return (
    <div data-testid="portfolio-myclinic" className="rounded-3xl border border-zinc-200 bg-white p-6">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <span className="text-xs font-bold uppercase tracking-wider text-zinc-400">Case Study</span>
        <span data-testid="portfolio-live-badge" className="inline-flex items-center gap-1.5 rounded-full bg-lime-100 px-3 py-1 text-xs font-bold text-lime-800">
          <span className="relative flex h-2 w-2"><span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-lime-500 opacity-75" /><span className="relative inline-flex h-2 w-2 rounded-full bg-lime-600" /></span>
          Live & Running
        </span>
      </div>
      <h3 className="mt-3 text-xl font-extrabold tracking-tight">MyClinic — Sistem Manajemen Klinik Kecantikan</h3>
      <p className="mt-2 text-sm leading-relaxed text-zinc-600">
        Platform all-in-one untuk klinik kecantikan multi-cabang: booking pasien, rekam medis, POS kasir, hingga laporan performa CS/CRM.
      </p>
      <ul className="mt-4 flex flex-wrap gap-2">
        {FEATURES.map((f) => (
          <li key={f} className="inline-flex items-center gap-1 rounded-full border border-zinc-200 px-2.5 py-1 text-xs font-medium text-zinc-700">
            <CheckCircle2 className="h-3.5 w-3.5 text-lime-600" /> {f}
          </li>
        ))}
      </ul>
    </div>
  );
}

export default function LinkSolusi() {
  return (
    <LinkShell back title="Solusi — AI Business Builder" testId="link-solusi-page">
      <div {...fadeUp(0)}>
        <p className="text-xs font-bold uppercase tracking-wider text-lime-700">Solusi Digital</p>
        <h1 className="mt-1 text-3xl font-extrabold tracking-tight">Solusi yang Bisa Dibangun</h1>
        <p className="mt-2 text-sm text-zinc-500">Aplikasi custom yang dirancang sesuai alur kerja bisnismu.</p>
      </div>
      <div className="mt-6 grid gap-3 sm:grid-cols-2">
        {SOLUTIONS.map((s, i) => <div key={s.id} {...fadeUp(i + 1)}><SolutionCard s={s} /></div>)}
      </div>
      <h2 className="mt-10 text-lg font-extrabold tracking-tight">Portofolio</h2>
      <div {...fadeUp(7, "mt-3")}><PortfolioCard /></div>
      <a
        href={waLink("Halo, saya sudah melihat solusi yang bisa dibangun dan ingin konsultasi.")}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="solusi-cta"
        className="mt-8 flex w-full items-center justify-center gap-2 rounded-full bg-lime-400 px-5 py-4 font-bold text-zinc-950 shadow-[0_10px_30px_-10px_rgba(132,204,22,0.7)] transition-[transform,background-color] duration-200 hover:-translate-y-0.5 hover:bg-lime-300"
      >
        <MessageCircle className="h-5 w-5" /> Konsultasi Sekarang
      </a>
    </LinkShell>
  );
}
